module.exports = __webpack_public_path__ + "static/media/render.6d8b6325.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/angrypi/render.png
// module id = 824
// module chunks = 0